import { HttpInterceptorFn } from '@angular/common/http';
import { getTenantIdFromHostname } from '../utils/tenant-from-host';
import { environment } from '../../../environments/environment';

export const tenantInterceptor: HttpInterceptorFn = (req, next) => {
  const fromHost = getTenantIdFromHostname(
    typeof globalThis !== 'undefined' && 'location' in globalThis
      ? globalThis.location.hostname
      : '',
  );
  const fromEnv = environment.tenantId?.trim() || null;
  const tenantId = fromHost ?? fromEnv;
  if (!tenantId) {
    return next(req);
  }
  return next(
    req.clone({
      setHeaders: { 'x-tenant-id': tenantId },
    }),
  );
};
